import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from "@Shared/components/form/commonFormMeta";

export type TTransactionFormFieldsName = {
    transactionCode: string;
    referenceNumber: string;
    validatedStatus: string;
    cardNumber: string;
    startDate: string;
    expirationDate: string;
    cardSequenceNumber: string;
    transactionAmount: string;
    currency: string;
    purchaseDate: string;
    cardAcceptorID: string;
    city: string;
    name: string;
    zip: string;
    riskManagementGroup: string;
    originState: string;
    merchantCategory: string;
    country: string;
    terminalID: string;
    paymentChannel: string;
    merchantTransactionIndicator: string;
    riskIdentIndicator: string;
    [name: string]: string;
};

export interface ITransactionFormMeta {
    // Transaction information
    transactionCode: FormInputMeta;
    referenceNumber: FormInputMeta;
    validatedStatus: FormInputMeta;

    // Carrier information data
    cardNumber: FormInputMeta;
    startDate: FormInputMeta;
    expirationDate: FormInputMeta;
    cardSequenceNumber: FormInputMeta;

    // Amount information data
    transactionAmount: FormInputMeta;
    ceilingIndicator: FormInputMeta;
    currency: FormInputMeta;
    purchaseDate: FormInputMeta;

    // Merchant information data
    cardAcceptorID: FormInputMeta;
    name: FormInputMeta;
    riskManagementGroup: FormInputMeta;
    merchantCategory: FormInputMeta;
    terminalID: FormInputMeta;
    merchantTransactionIndicator: FormInputMeta;
    city: FormInputMeta;
    zip: FormInputMeta;
    originState: FormInputMeta;
    country: FormInputMeta;
    paymentChannel: FormInputMeta;
    riskIdentIndicator: FormInputMeta;

    schema: any;
}

const transactionFormMeta = {} as ITransactionFormMeta;

// Transaction information
transactionFormMeta.transactionCode = {... commonFormMeta.transactionCode};

transactionFormMeta.referenceNumber = {
  name: "referenceNumber",
  type: "text",
  label: "Numéro Référence",
  placeholder: "",
  validation: yup.string(),
};

transactionFormMeta.validatedStatus = {
  name: "validatedStatus",
  type: "text",
  label: "Statut Validé",
  placeholder: "",
  validation: yup.string(),
};

// Carrier information data
transactionFormMeta.cardNumber = {
  name: "cardNumber",
  type: "text",
  label: "Numéro Carte",
  placeholder: "",
  validation: yup.string(),
};

transactionFormMeta.startDate = {
  name: "startDate",
  type: "text",
  label: "Date Début",
  placeholder: "",
  validation: yup.string(),
};

transactionFormMeta.expirationDate = {
  name: "expirationDate",
  type: "text",
  label: "Date Expiration",
  placeholder: "",
  validation: yup.string(),
};

transactionFormMeta.cardSequenceNumber = {
  name: "cardSequenceNumber",
  type: "text",
  label: "Numéro Séquence Carte",
  placeholder: "",
  validation: yup.string(),
};

// Amount information data
transactionFormMeta.transactionAmount = {
    name: "transactionAmount",
    type: "text",
    label: "Montant Transaction",
    placeholder: "",
    validation: yup.string(),
};
  
transactionFormMeta.ceilingIndicator = {
    name: "ceilingIndicator",
    type: "text",
    label: "Indicateur Plafond",
    placeholder: "",
    validation: yup.string(),
};
  
transactionFormMeta.currency = {
    name: "currency",
    type: "text",
    label: "Devise",
    placeholder: "",
    validation: yup.string(),
};
  
transactionFormMeta.purchaseDate = {
    name: "purchaseDate",
    type: "text",
    label: "Date Achat",
    placeholder: "",
    validation: yup.string(),
};
  
// Merchant information data
transactionFormMeta.cardAcceptorID = {
    name: "cardAcceptorID",
    type: "text",
    label: "ID Accepteur Carte",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.city = {
    name: "city",
    type: "text",
    label: "Ville",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.name = {
    name: "name",
    type: "text",
    label: "Nom",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.zip = {
    name: "zip",
    type: "text",
    label: "ZIP",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.riskManagementGroup = {
    name: "riskManagementGroup",
    type: "text",
    label: "Groupe Gestion Risque",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.originState = {
    name: "originState",
    type: "text",
    label: "État Provenance",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.merchantCategory = {
    name: "merchantCategory",
    type: "text",
    label: "Catégorie Commerçant",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.country = {
    name: "country",
    type: "text",
    label: "Pays",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.terminalID = {
    name: "terminalID",
    type: "text",
    label: "ID Terminal",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.paymentChannel = {
    name: "paymentChannel",
    type: "text",
    label: "Canal Paiement",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.merchantTransactionIndicator = {
    name: "merchantTransactionIndicator",
    type: "text",
    label: "Indicateur Transaction Commerçant",
    placeholder: "",
    validation: yup.string(),
};

transactionFormMeta.riskIdentIndicator = {
    name: "riskIdentIndicator",
    type: "text",
    label: "Indicateur Ident. Risque",
    placeholder: "",
    validation: yup.string(),
};


transactionFormMeta.schema = yup.object().shape(getValidationSchema(transactionFormMeta));

export default transactionFormMeta;